import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { showMessage } from '../context/MessageContext.jsx';
import Input from '../components/ui/Input.jsx';
import Button from '../components/ui/Button.jsx';
import './Login.css';

/**
 * Login page component
 */
export default function Login() {
  const [tallyUserId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [rememberDevice, setRememberDevice] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!tallyUserId || !password) {
      showMessage('Please Enter User Id and Password.', 'error');
      return;
    }

    try {
      setLoading(true);
      await login(tallyUserId, password);
      navigate('/');
    } catch (err) {
      setLoading(false);
      // Check if it's an expiry error (403 status)
      const errorMessage = err?.response?.data?.message || err?.message || 'Login failed. Check credentials.';
      if (errorMessage.includes('expired')) {
        showMessage(errorMessage, 'error');
      } else {
        showMessage(errorMessage, 'error');
      }
    }
  };

  return (
    <main className="login-page">
      <div className="login-container">
        {/* Logo and Heading */}
        <div className="login-header">
          <img
            src="/images/logosetu.jpg"
            alt="SetuLink Logo"
            className="login-logo"
          />
          <p className="login-tagline">
            "Mobile Par Likho, Tally Par Dekho."
          </p>
        </div>

        <div className="login-title-section">
          <h3 className="login-title">Login Form</h3>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="login-form">
          <Input
            label="User ID"
            id="tallyUserId"
            name="tallyUserId"
            type="text"
            value={tallyUserId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder="Please enter your userId"
            required
            error={error}
          />

          <Input
            label="Password"
            id="password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Please enter your password"
            required
          />

          <div className="login-options">
            <div className="login-checkbox">
              <input
                type="checkbox"
                id="rememberDevice"
                checked={rememberDevice}
                onChange={(e) => setRememberDevice(e.target.checked)}
              />
              <label htmlFor="rememberDevice">Remember this device</label>
            </div>
          </div>

          <Button
            type="submit"
            variant="primary"
            fullWidth
            loading={loading}
            className="login-submit-button"
          >
            {!loading && (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <path d="M16 8a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .252.434l2.5 1.5a.5.5 0 0 0 .496-.868L11.5 10.5V7.5z" />
                </svg>
                Sign In
              </>
            )}
          </Button>
        </form>

        <p className="login-footer">
          By signing in you agree to our{' '}
          <a href="#" className="login-link">
            Terms
          </a>{' '}
          and{' '}
          <a href="#" className="login-link">
            Privacy
          </a>
          .
        </p>
      </div>
    </main>
  );
}